import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '@app/core/services/data-task.service';
import { StateService } from '@app/core/services/state.service';
import { UtilityService } from '@app/core/services/utility.service';
import { QuickAccessItem, QuickAccessService } from './quick-access.service';

@Component({
    selector: 'tt-quick-access',
    templateUrl: './quick-access.component.html',
    styleUrls: ['./quick-access.component.css'],
})
export class QuickAccessComponent implements OnInit {
    public quickAccessList: QuickAccessItem[] = [];

    constructor(
        public quickAccess: QuickAccessService,
        private state: StateService,
        private utility: UtilityService,
    ) {}

    public getIcon(item: QuickAccessItem) {
        let icon = item.item_glyphicon;

        if (!!icon && icon.startsWith('fa') && [2, 3].includes(icon.indexOf('-'))) {
            icon = `fa${icon.slice(icon.indexOf('-'))}`;
        } else if (!!icon && icon.startsWith('glyphicon')) {
            icon = 'glyphicon ' + icon;
        }

        return icon || 'fa-arrow-right';
    }

    public async quickAccessGoto(event: { item: QuickAccessItem; event: MouseEvent }) {
        let itemState = event.item.item_state;
        let itemParms = event.item.item_parms;

        if (event.item.item_state === 'dynamicdatataskgoto' && !!itemParms) {
            const response = await this.quickAccess.getDynamicDatataskGoto({ p2_datatask_keyno: '' + itemParms });

            if (response.item_state !== '') {
                itemState = response.item_state;
                itemParms = response.item_parms;
            }
        }

        if (!itemState) return;

        if (this.utility.isModifierKeyPressed(event.event)) {
            this.state.newTab(itemState, itemParms);
        } else {
            this.state.go(itemState, itemParms);
        }
    }

    private async loadQuickAccessList() {
        // this.quickAccessList = await this.quickAccess.getQuickAccessList();
        this.quickAccess.loadQuickAccessListObservable();
    }

    private async init() {
        this.loadQuickAccessList();
    }

    ngOnInit(): void {
        this.init();
    }
}
